import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { createGraphNodeClicker, DashboardGraph, LineChart } from 'graph'
import { useGraphFetch, constants } from '../module'
import { useSelectedFleetIds } from 'features/settings'
import { v4 as uuid } from 'uuid'
import { types as emissionTypes } from 'features/report-vehicle-emissions'


const Graph = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const selectedFleetIds = useSelectedFleetIds()

  const { loading, error, data } = useGraphFetch()
  const path = '/reports/fuel-exceptions'
  const missingPath = '/reports/missing-odometers'

  const onClick = createGraphNodeClicker(data?.ranges, (key, value) => {
    if (key && value) {
      dispatch({
        type: emissionTypes.SET_DASHBOARD_FILTER,
        payload: true,
      })
      navigate(`${path}?${key}=${value}`)
    } else {
      navigate(`${path}`)
    }
  })

  const onLegendCountClick = useCallback((legendBaseLabel) => {
    navigate(`${path}?exception=${encodeURIComponent(legendBaseLabel)}`)
  }, [navigate, path])

  const onRefresh = () => {
    dispatch({
      type: constants.REQUEST_DATA,
      payload: null,
      options: {
        queryParams: { FleetId: selectedFleetIds.join() },
        requestId: uuid(),
      },
    })
  }

  return (
    <DashboardGraph
      title="Exceptions Trend"
      to={path}
      loading={loading}
      error={error}
      onRefresh={onRefresh}
      data={data}
      minHeight={300}>
      <div
        style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <LineChart data={data} onClick={onClick} onLegendCountClick={onLegendCountClick} noDataMessage="No fuel exception data available for the selected fleet" />

        {data?.totalOdometers > 0 && (
          <div
            style={{
              marginTop: 40,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 8,
            }}>
            <div
              role="button"
              tabIndex={0}
              onClick={() =>
                navigate(
                  `${missingPath}`
                )
              }
              style={{
                border: '2px solid #000000ff',
                color: '#000000ff',
                padding: '6px 14px',
                fontSize: 13,
                borderRadius: 10,
                display: 'inline-block',
                fontWeight: 500,
                cursor: 'pointer',
                whiteSpace: 'nowrap',
              }}
              aria-label="Open Missing Odometers report">
              Missing Odometers ({data?.totalOdometers})
            </div>
          </div>
        )}
      </div>
    </DashboardGraph>
  )
}

export default Graph
